var map = {
	"./1.png": "./src/images/gallery/Python Automation/1.png",
	"./2.png": "./src/images/gallery/Python Automation/2.png",
	"./3.png": "./src/images/gallery/Python Automation/3.png",
	"./4.png": "./src/images/gallery/Python Automation/4.png",
	"./5.png": "./src/images/gallery/Python Automation/5.png",
	"./6.png": "./src/images/gallery/Python Automation/6.png",
	"./cover.png": "./src/images/gallery/Python Automation/cover.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images/gallery/Python Automation sync \\.(png%7Cjpe?g%7Csvg)$";